export default [
  {
    path: "/qspiFacilityOutbound",
    component: () => import("@/components/page/QSPI/ReceiveVolume/facilityDc"),
    meta: { title: "DC月度各Facility发货量" },
  },
  {
    path: "/qspiDCOutbound",
    component: () => import("@/components/page/QSPI/ReceiveVolume/DCOutbound"),
    meta: { title: "DC发货量(RMC月度)" },
  },
  {
    path: "/qspiGC",
    component: () => import("@/components/page/QSPI/ReceiveVolume/QueryGc"),
    meta: { title: "GC(月度)" },
  },
  {
    path: "/qspiDCInbound",
    component: () => import("@/components/page/QSPI/ReceiveVolume/DCReceive"),
    meta: { title: "DC月度收货量" },
  },
];
